export const NAME = 'shoppingProgress';